import script from "./ConsoleLogs.vue?vue&type=script&lang=js"
export * from "./ConsoleLogs.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__